<template>
  <el-table-column label="" width="40" header-align="center" type="expand">
    <template #default="scope">
      <el-table :data="objectToArray(scope.row.tracking)">
        <el-table-column prop="name" label="Tracked Clicks" width="300">
          <template #default="subScope">
            {{ displayNames[subScope.row.name] || subScope.row.name }}
          </template>
        </el-table-column>
        <el-table-column label="Value" width="100">
          <template #default="subScope">
            <ul>
              <li v-for="(item, index) in subScope.row.value" :key="index">
                {{ item.value }}
              </li>
            </ul>
          </template>
        </el-table-column>
        <el-table-column label="Time">
          <template #default="subScope">
            <ul>
              <li v-for="(item, index) in subScope.row.value" :key="index">
                {{ formatDate(item.timestamp, true) }}
              </li>
            </ul>
          </template>
        </el-table-column>
      </el-table>
      <div class="mb-8 w-full h-4" />
    </template>
  </el-table-column>
</template>

<script setup>
import { formatDate } from "@/utils";

const displayNames = {
  starChoiceClicked: "Star Choice Clicks",
  payByCardButtonClicked: "Pay By Card Dropdown Clicks",
  bankWireZelleButtonClicked: "Bank Wire/Zelle Dropdown Clicks",
  choiceReviewButtonClicked: "Review Choice",
};

const objectToArray = (obj) => {
  if (!obj) {
    return [];
  }
  return Object.keys(obj).map((key) => {
    return { name: key, value: obj[key] };
  });
};
</script>

<style scoped>
::v-deep .el-table__expand-icon > .el-icon {
  font-size: 20px;
  border: 1px solid white;
  border-radius: 25%;
}
</style>
